export class SyCampocalculadoPk {
    registronumero: number;

}
export class SyCampocalculado {
    pk: SyCampocalculadoPk;

    constructor() {
        this.pk = new SyCampocalculadoPk();
    }

    monto01: number;
    monto02: number;
    monto03: number;
    monto04: number;
    monto05: number;
    monto06: number;
    monto07: number;
    monto08: number;
    monto09: number;
    monto10: number;

    flag01: string;
    flag02: string;
    flag03: string;
    flag04: string;
    flag05: string;

    descripcion01: string;
    descripcion02: string;
    descripcion03: string;
    descripcion04: string;
    descripcion05: string;

    codigo01: string;
    codigo02: string;
    codigo03: string;
    codigo04: string;
    codigo05: string;

    fecha01: Date;
    fecha02: Date;
    fecha03: Date;
    fecha04: Date;
    fecha05: Date;
}   
